const state = {
  partnerships: [],
  totalElmts: undefined,
  layout: {
    isViewCardActive: false,
  },
  navigation: {
    currentGroup: undefined,
    asidePath: [],
    asideElmts: [],
  },
  partnershipsGroups: [],
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/partnerships/state.js